<template>
  <div>
    <div class="toolbar">
      <a class="button is-warning" @click="$router.back()">Go Back</a>
      <b-dropdown v-model="sortBy" class="is-primary">
        <button class="button is-primary" slot="trigger" style="text-transform: capitalize">
          Sort By: {{sortBy.toLowerCase().replace('_', ' ')}}
          <b-icon icon="menu-down"></b-icon>
        </button>
        <b-dropdown-item value="total_price">Total Price</b-dropdown-item>
        <b-dropdown-item value="depart_time">Depart Time</b-dropdown-item>
        <b-dropdown-item value="arrive_time">Arrive Time</b-dropdown-item>
      </b-dropdown>
    </div>
    <div class="tile is-ancestor" style="margin-top: 20px">
      <div class="tile is-parent is-vertical is-12">
        <itinerary v-for="itin in getSortedFilteredItins.slice(0, limit)" v-on:add-to-cart="addToCart"
                   :itinerary=itin></itinerary>
      </div>
    </div>
    <button class="button is-primary bottom" @click="limit += 10" v-if="limit < getSortedFilteredItins.length">
      View More
    </button>
    <span v-else class="bottom">
      End of results
    </span>
  </div>
</template>

<script>
  import PermutationGroup from "./PermutationGroup";
  import Itinerary from "./Itinerary";
  import IconSegments from "./IconSegments";
  import axios from 'axios';
  export default {
    name: 'Itineraries',
    props: ['itineraries', 'direction', 'permutation'],
    components: {'itinerary': Itinerary, 'icon-segments': IconSegments},
    data() {
      return {
        limit: 10,
        sortBy: 'total_price',
      };
    },
    computed: {
      getSortedFilteredItinsTotalPrice: function () {
        return [...this.itineraries].sort((a, b) => a.total_price - b.total_price)
      },
      getSortedFilteredItinsDepart: function () {
        return [...this.itineraries].sort((a, b) => {
          const a_segs = (a.departing_segments || a.returning_segments);
          const b_segs = (b.departing_segments || b.returning_segments);
          return a_segs[0].depart_time > b_segs[0].depart_time ? 1 : -1;
        })
      },
      getSortedFilteredItinsArrive: function () {
        return [...this.itineraries].sort((a, b) => {
          const a_segs = (a.departing_segments || a.returning_segments);
          const b_segs = (b.departing_segments || b.returning_segments);
          return a_segs[a_segs.length - 1].arrive_time > b_segs[b_segs.length - 1].arrive_time ? 1 : -1;
        })
      },
      getSortedFilteredItins: function () {
        const by = this.sortBy;
        if (by === 'total_price') return this.getSortedFilteredItinsTotalPrice;
        else if (by === 'depart_time') return this.getSortedFilteredItinsDepart;
        else return this.getSortedFilteredItinsArrive;
      },
    },
    methods: {
      addToCart(itinerary) {
        this.$emit('add-to-cart', itinerary)
      },
      isOdd(e) {
        return e % 2 === 0;
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bottom {
    margin: 20px auto 40px auto;
  }

  .toolbar {
    margin: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Itineraries.vue